<template>
  <div class="image-uploader--wrapper">
    <v-hover v-slot="{ hover }">
      <v-card class="mx-auto" max-width="600">
        <v-img alt="avatar" :lazy-src="avatarImg" :src="avatarImg" @click="isVisible = true" max-height="380" :eager="true" >
          <template v-if="image === 'empty'">
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular
                  color="primary"
                  indeterminate
              ></v-progress-circular>
            </div>
          </template>
          <v-expand-transition>
            <div
                v-if="hover"
                class="d-flex transition-fast-in-fast-out grey grey-darken-4 overlay text-h4 white--text align-center justify-center"
                style="height: 100%;"
            >
              <v-icon class="white--text text-h4">mdi-pencil</v-icon>
              {{ $t('click_to_change_image') }}
            </div>
          </v-expand-transition>
        </v-img>

      </v-card>
    </v-hover>
    <image-uploader
        class="image-uploader"
        :no-circle="true"
        :langType="lang"
        @crop-success="cropSuccess"
        v-model="isVisible"
        :width="420"
        :height="300"
    />
  </div>
</template>
<script>
import ImageUploader from 'vue-image-crop-upload/upload-2.vue';
export default {
  name: "ImageCropper",
  components: {"image-uploader": ImageUploader},
  props: {
    image: {
      type: String,
    }
  },
  data: () => ({
    isVisible: false,
  }),
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    avatarImg() {
      return this.image ?? require('@/assets/avatar.jpg')
    }
  },
  methods: {
    cropSuccess(imgDataUrl){
      this.$emit('crop', imgDataUrl);
    },
  }
}
</script>
<style scoped>
.overlay {
  background-color: #9e9e9ebd !important;
  cursor: pointer;
}
</style>